module.exports = __webpack_public_path__ + "img/icon_utill_tool.a7a4588e.svg";